import { useEffect, useState } from 'react';
import Mask from '../Mask/';
import Styles from './AdAlert.module.scss';
import AdImg from '@/assets/images/ads/20240926-20241015.png'
import CloseIcon from '@/assets/icons/close.svg'

function isInPromoteRange() {
  const currentDate = new Date();
  const startDate = new Date('2024-09-26T00:00:00');
  const endDate = new Date('2024-10-15T23:59:59');
  return currentDate >= startDate && currentDate <= endDate;
}

const LAST_OPEN_YMD = 'last_open_ymd';

function AdAlert() {
  const [showAd, setShowAd] = useState(false);

  useEffect(() => {
    const lastStr = localStorage.getItem(LAST_OPEN_YMD);
    const currentDate = new Date();
    const currStr = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    if (lastStr !== currStr) {
      setShowAd(true);
      
    }
  }, [])


  // 如果不在活动期间，直接跳过
  if (!isInPromoteRange()) {
    return null;
  }

  return (
    <Mask visible={showAd}>
      <div className={Styles.adContainer}>
        <img className={Styles.adImg} src={AdImg} alt="ad" />
        <div className={Styles.closeBtn} onClick={() => {
          setShowAd(false);
          const currentDate = new Date();
          const currStr = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
          localStorage.setItem(LAST_OPEN_YMD, currStr);
        }}>
          <img src={CloseIcon} alt="close" />
        </div>
      </div>
    </Mask>
  );
}

export default AdAlert;
